import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['item']

  showItemBenefit(){
    this.itemTarget.hidden = !this.itemTarget.hidden
  }
}